import { FC, memo, useMemo } from "react";
import RateConditionsRenderer from "./RateConditionsRenderer";
import { MdInfoOutline } from "react-icons/md";
import { useTranslation } from "react-i18next";

const HotelPoliciesCard: FC<{ rateConditions: string[] }> = ({ rateConditions }) => {
  const { t } = useTranslation();
  const safeConditions = useMemo(() => (rateConditions ?? []).filter((c) => c && c.trim()), [rateConditions]);

  return (
    <div className="border-border-default flex flex-col gap-4 rounded-lg border bg-background-default p-6">
      <h2 className="text-font-default text-xl font-medium">{t("UserHistory.hotel.policiesAndInformation")}</h2>
      <div className="text-14 text-font-subtle leading-relaxed">
        {safeConditions.length > 0 ? (
          <RateConditionsRenderer conditions={safeConditions} />
        ) : (
          <div className="bg-background-minimal flex items-center gap-2 rounded-md p-4">
            <MdInfoOutline className="size-4 shrink-0 text-icon-minimal" />
            <p className="text-14 text-font-subtle m-0 leading-normal">{t("UserHistory.hotel.noPolicyInfo")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(HotelPoliciesCard);
